export default {"src":"/_next/static/media/credit-card.9765830a.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};